export {default as Card } from './ModalCard';
export {default as Header} from './ModalCardHeader';
export {default as Title} from './ModalCardTitle';
export {default as Body} from './ModalCardBody';
export {default as Footer} from './ModalCardFooter';


// WEBPACK FOOTER //
// ./src/components/Modal/Card/index.ts